import { render } from "./ContentDisplay.vue?vue&type=template&id=79b7b7cc"
import script from "./ContentDisplay.vue?vue&type=script&lang=js"
export * from "./ContentDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__